import { useEffect, useState } from 'react';

const useUniquePrefix = (): string => {
  const [id, setId] = useState<string>('');
  useEffect(() => {
    setId(`p-${Math.round(Math.random() * 1e5)}`);
  }, []);
  return id;
};

export default useUniquePrefix;
